import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select'
import PubSub from 'pubsub-js';

import options from '../Avatar/options';

class AvatarEditor extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      topType: options.topType.find(option => option.value === props.topType),
      accessoriesType: options.accessoriesType.find(option => option.value === props.accessoriesType),
      hatColor: options.hatColor.find(option => option.value === props.hatColor),
      hairColor: options.hairColor.find(option => option.value === props.hairColor),
      facialHairType: options.facialHairType.find(option => option.value === props.facialHairType),
      facialHairColor: options.facialHairColor.find(option => option.value === props.facialHairColor),
      clotheType: options.clotheType.find(option => option.value === props.clotheType),
      clotheColor: options.clotheColor.find(option => option.value === props.clotheColor),
      graphicType: options.graphicType.find(option => option.value === props.graphicType),
      eyeType: options.eyeType.find(option => option.value === props.eyeType),
      eyebrowType: options.eyebrowType.find(option => option.value === props.eyebrowType),
      mouthType: options.mouthType.find(option => option.value === props.mouthType),
      skinColor: options.skinColor.find(option => option.value === props.skinColor)
    };

    this.onChange = this.onChange.bind(this);
  }

  onChange (type, option) {
    this.setState(prevState => {
      prevState[type] = option;
      return prevState;
    }, () => {
      PubSub.publish('AVATAR_CHANGE', { type, value: option.value });
    });
  }

  render() {
    return (
      <div className="-mt-4">
        <div className="flex flex-col md:flex-row items-center mt-4">
          <label className="w-full md:w-1/3 mt-2"><span className="mr-1">🎨</span> Couleur de peau</label>
          <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.skinColor} name="user[avatar_skin_color]" value={this.state.skinColor} onChange={value => this.onChange('skinColor', value)} />
        </div>

        <div className="flex flex-col md:flex-row items-center mt-4">
          <label className="w-full md:w-1/3 mt-2"><span className="mr-1">💇</span> Coiffure / chapeau</label>
          <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.topType} name="user[avatar_top_type]" value={this.state.topType} onChange={value => this.onChange('topType', value)} />
        </div>

        { this.state.topType.value != "Eyepatch" && (
          <div className="flex flex-col md:flex-row items-center mt-4">
            <label className="w-full md:w-1/3 mt-2"><i className="fas fa-level-up-alt transform rotate-90 text-sm ml-4 mr-3 inline-block"></i><span className="mr-1">🕶️</span> Accessoire</label>
            <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.accessoriesType} name="user[avatar_accessories_type]" value={this.state.accessoriesType} onChange={value => this.onChange('accessoriesType', value)} />
          </div>
        ) }

        { ['Hijab', 'Turban', 'WinterHat1', 'WinterHat2', 'WinterHat3', 'WinterHat4'].indexOf(this.state.topType.value) >= 0 && (
          <div className="flex flex-col md:flex-row items-center mt-4">
            <label className="w-full md:w-1/3 mt-2"><i className="fas fa-level-up-alt transform rotate-90 text-sm ml-4 mr-3 inline-block"></i><span className="mr-1">🎨</span> Couleur du chapeau</label>
            <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.hatColor} name="user[avatar_hat_color]" value={this.state.hatColor} onChange={value => this.onChange('hatColor', value)} />
          </div>
        ) }

        { this.state.topType.value != "NoHair" && this.state.topType.value.indexOf('Hair') >= 0 && (
          <div className="flex flex-col md:flex-row items-center mt-4">
            <label className="w-full md:w-1/3 mt-2"><i className="fas fa-level-up-alt transform rotate-90 text-sm ml-4 mr-3 inline-block"></i><span className="mr-1">🎨</span> Couleur des cheveux</label>
            <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.hairColor} name="user[avatar_hair_color]" value={this.state.hairColor} onChange={value => this.onChange('hairColor', value)} />
          </div>
        ) }

        { this.state.topType.value != "Hijab" && (
          <div className="flex flex-col md:flex-row items-center mt-4">
            <label className="w-full md:w-1/3 mt-2"><span className="mr-1">🐻</span> Pilosité</label>
            <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.facialHairType} name="user[avatar_facial_hair_type]" value={this.state.facialHairType} onChange={value => this.onChange('facialHairType', value)} />
          </div>
        ) }

        { this.state.topType.value != "Hijab" && this.state.facialHairType.value != "Blank" && (
          <div className="flex flex-col md:flex-row items-center mt-4">
            <label className="w-full md:w-1/3 mt-2"><i className="fas fa-level-up-alt transform rotate-90 text-sm ml-4 mr-3 inline-block"></i><span className="mr-1">✂️</span> Couleur de la pilosité</label>
            <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.facialHairColor} name="user[avatar_facial_hair_color]" value={this.state.facialHairColor} onChange={value => this.onChange('facialHairColor', value)} />
          </div>
        ) }

        <div className="flex flex-col md:flex-row items-center mt-4">
          <label className="w-full md:w-1/3 mt-2"><span className="mr-1">👔</span> Vêtement</label>
          <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.clotheType} name="user[avatar_clothe_type]" value={this.state.clotheType} onChange={value => this.onChange('clotheType', value)} />
        </div>

        { ['BlazerShirt', 'BlazerSweater'].indexOf(this.state.clotheType.value) == -1 && (
          <div className="flex flex-col md:flex-row items-center mt-4">
            <label className="w-full md:w-1/3 mt-2"><i className="fas fa-level-up-alt transform rotate-90 text-sm ml-4 mr-3 inline-block"></i><span className="mr-1">🧵</span> Couleur du vêtement</label>
            <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.clotheColor} name="user[avatar_clothe_color]" value={this.state.clotheColor} onChange={value => this.onChange('clotheColor', value)} />
          </div>
        ) }

        { this.state.clotheType.value.indexOf('Graphic') >= 0 && (
          <div className="flex flex-col md:flex-row items-center mt-4">
            <label className="w-full md:w-1/3 mt-2"><i className="fas fa-level-up-alt transform rotate-90 text-sm ml-4 mr-3 inline-block"></i><span className="mr-1">💀</span> Motif</label>
            <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.graphicType} name="user[avatar_graphic_type]" value={this.state.graphicType} onChange={value => this.onChange('graphicType', value)} />
          </div>
        ) }

        <div className="flex flex-col md:flex-row items-center mt-4">
          <label className="w-full md:w-1/3 mt-2"><span className="mr-1">👁️</span> Yeux</label>
          <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.eyeType} name="user[avatar_eye_type]" value={this.state.eyeType} onChange={value => this.onChange('eyeType', value)} />
        </div>

        <div className="flex flex-col md:flex-row items-center mt-4">
          <label className="w-full md:w-1/3 mt-2"><span className="mr-1">✏️</span> Sourcils</label>
          <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.eyebrowType} name="user[avatar_eyebrow_type]" value={this.state.eyebrowType} onChange={value => this.onChange('eyebrowType', value)} />
        </div>

        <div className="flex flex-col md:flex-row items-center mt-4">
          <label className="w-full md:w-1/3 mt-2"><span className="mr-1">👄</span> Bouche</label>
          <Select placeholder="Choisir" className="w-full md:w-2/3" options={options.mouthType} name="user[avatar_mouth_type]" value={this.state.mouthType} onChange={value => this.onChange('mouthType', value)} />
        </div>
      </div>
    );
  }
}

AvatarEditor.propTypes = {
  topType: PropTypes.string,
  accessoriesType: PropTypes.string,
  hatColor: PropTypes.string,
  hairColor: PropTypes.string,
  facialHairType: PropTypes.string,
  facialHairColor: PropTypes.string,
  clotheType: PropTypes.string,
  clotheColor: PropTypes.string,
  graphicType: PropTypes.string,
  eyeType: PropTypes.string,
  eyebrowType: PropTypes.string,
  mouthType: PropTypes.string,
  skinColor: PropTypes.string
};

AvatarEditor.defaultProps = {
  topType: 'LongHairStraight',
  accessoriesType: 'Blank',
  hatColor: 'Red',
  hairColor: 'BrownDark',
  facialHairType: 'Blank',
  facialHairColor: 'BrownDark',
  clotheType: 'BlazerShirt',
  clotheColor: 'Gray02',
  graphicType: 'Skull',
  eyeType: 'Default',
  eyebrowType: 'Default',
  mouthType: 'Default',
  skinColor: 'Light'
};

export default AvatarEditor;
